interface ResolveInsurancePaymentRequestParams {
  bookingId?: string
  sessionId?: string
}

export function resolveInsurancePaymentRequest({
  bookingId,
  sessionId,
}: ResolveInsurancePaymentRequestParams) {
  if (sessionId) {
    return {
      payload: { sessionId },
      url: `/booking-session/${sessionId}/insurance-payment`,
    }
  }

  if (bookingId) {
    return {
      payload: undefined,
      url: `/me/bookings/${bookingId}/insurance/initiate`,
    }
  }

  return null
}
